module.exports = __webpack_public_path__ + "assets/img/declaration.d6db016.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/declaration.jpeg
// module id = Gk/F
// module chunks = 1